class GorgiasChatLauncher extends HTMLElement {
  #button;
  #onWidgetLoaded;

  connectedCallback() {
    this.#button = this.querySelector('[data-gorgias-launcher]');
    if (!this.#button) return;

    this.#button.addEventListener('click', this.#handleClick);

    // Gorgias's async SDK can define window.GorgiasChat before the API is
    // ready — methods like isOpen/close/on are only safe after init().
    // Official pattern: await GorgiasChat.init() when the object exists;
    // otherwise wait for the one-shot gorgias-widget-loaded event.
    // https://docs.gorgias.com/en-US/customize-the-chat-widget-with-HTML-and-JavaScript-286032
    if (window.GorgiasChat) {
      window.GorgiasChat.init().then(this.#handleWidgetLoaded).catch(this.#handleInitError);
    } else {
      this.#onWidgetLoaded = this.#handleWidgetLoaded;
      window.addEventListener('gorgias-widget-loaded', this.#onWidgetLoaded, { once: true });
    }
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#handleClick);
    if (this.#onWidgetLoaded) {
      window.removeEventListener('gorgias-widget-loaded', this.#onWidgetLoaded);
    }
  }

  #handleClick = () => {
    if (!window.GorgiasChat) return;

    if (window.GorgiasChat.isOpen()) {
      window.GorgiasChat.close();
    } else {
      window.GorgiasChat.open();
    }
  };

  #handleWidgetLoaded = () => {
    if (!this.isConnected || !this.#button) return;

    this.#button.disabled = false;
    this.#button.ariaExpanded = window.GorgiasChat.isOpen() ? 'true' : 'false';

    window.GorgiasChat.on('widget:opened', () => (this.#button.ariaExpanded = 'true'));
    window.GorgiasChat.on('widget:closed', () => (this.#button.ariaExpanded = 'false'));
  };

  #handleInitError = (error) => {
    console.error('[gorgias-chat] failed to initialize', error);
  };
}

customElements.define('gorgias-chat-launcher', GorgiasChatLauncher);
